import { BaseService } from '@Services/index'

export class BlogService extends BaseService {
	
	public getNewsList(page: number): Promise<any> {
		return super.get(`/news/${page}/`)
	}
}